var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      true
        ? _c(
            "FormTitle",
            {
              staticClass: "pa-4 pt-0",
              attrs: { dark: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "subtitle",
                    fn: function () {
                      return [_vm._v("Thanks for being a student!")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2036241735
              ),
            },
            [_vm._v("So Long, Farewell\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.memberships.length
        ? _c("FormItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "question",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            Which membership would you like to cancel?\n        "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "response",
                  fn: function () {
                    return [
                      _c("v-select", {
                        attrs: {
                          items: _vm.memberships,
                          "item-value": "id",
                          "item-text": "name",
                          label: "Select a membership",
                          rules: [(v) => !!v || "You must select a membership"],
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.getUpcomingLessons()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        domProps: {
                                          innerHTML: _vm._s(data.item.name),
                                        },
                                      }),
                                      _vm._v(" "),
                                      data.item.details
                                        ? _c("v-list-item-subtitle", [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  `${
                                                    data.item.details.location
                                                  } | ${
                                                    data.item.details
                                                      ?.instrument ?? "Class"
                                                  }`
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1118012668
                        ),
                        model: {
                          value: _vm.form.purchase_option_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "purchase_option_id", $$v)
                          },
                          expression: "form.purchase_option_id",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3422240367
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.memberships.length
        ? _c("v-container", [
            _c(
              "div",
              { staticClass: "pa-2 white--text text-align-start text-lg" },
              [
                _vm._v(
                  "\n            We can't find any memberships on your account. Please contact\n            one of our studios for help.\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.purchase_option_id
        ? _c("FormItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "question",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            Please select your final lesson date. It should be AT LEAST 30\n            days from today. Even if it is not, you will still be billed for\n            the next 30 days in accordance with the withdrawal policy in\n            your student contract.\n        "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "response",
                  fn: function () {
                    return [
                      _c("SoliDate", {
                        staticClass: "w-full",
                        attrs: {
                          events: _vm.upcomingLessons,
                          icon: null,
                          loading: _vm.lessonsLoading,
                          rules: [
                            (v) => !!v || "You must select a final lesson date",
                          ],
                          noLimit: "",
                          select: false,
                        },
                        model: {
                          value: _vm.form.final_lesson_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "final_lesson_date", $$v)
                          },
                          expression: "form.final_lesson_date",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3357228251
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.form.final_lesson_date
        ? _c(
            "div",
            [
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [_vm._v(" Why are you withdrawing? ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c("v-textarea", {
                            attrs: {
                              label: "Please briefly explain",
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              rules: _vm.rules_text_limit,
                              counter: "",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.form.why_exit_reason,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "why_exit_reason", $$v)
                              },
                              expression: "form.why_exit_reason",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1422596315
                ),
              }),
              _vm._v(" "),
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                Was your teacher a good fit for you and your goals?\n            "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c(
                            "v-radio-group",
                            {
                              staticClass: "mt-0",
                              model: {
                                value: _vm.form.perfect_match,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "perfect_match", $$v)
                                },
                                expression: "form.perfect_match",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "Yes", value: true },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: { label: "No", value: false },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              label: "Please briefly say why",
                              "hide-details": "auto",
                              rules: _vm.rules_text_limit,
                              counter: "",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.form.perfect_match_reason,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "perfect_match_reason", $$v)
                              },
                              expression: "form.perfect_match_reason",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              label: "I'd like to keep my answer confidential",
                            },
                            model: {
                              value: _vm.form.confidential,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "confidential", $$v)
                              },
                              expression: "form.confidential",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4085903043
                ),
              }),
              _vm._v(" "),
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                How likely are you to recommend "
                          ),
                          _c("u", [_vm._v("your teacher")]),
                          _vm._v(
                            " to a\n                friend or colleague?\n            "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c("NPSOptions", {
                            model: {
                              value: _vm.form.nps_teacher_value,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "nps_teacher_value", $$v)
                              },
                              expression: "form.nps_teacher_value",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1199006316
                ),
              }),
              _vm._v(" "),
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                How likely are you to recommend "
                          ),
                          _c("u", [_vm._v("Musicologie")]),
                          _vm._v(
                            " to a\n                friend or colleague?\n            "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c("NPSOptions", {
                            model: {
                              value: _vm.form.nps_value,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "nps_value", $$v)
                              },
                              expression: "form.nps_value",
                            },
                          }),
                          _vm._v(" "),
                          _vm.form.nps_value >= 8
                            ? _c(
                                "div",
                                {
                                  staticClass: "soli-grey text-start",
                                  staticStyle: { display: "block" },
                                },
                                [
                                  _vm._v(
                                    "\n                    Awesome!\n                    "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://musicologielessons.com/review",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("Go here to review us")]
                                  ),
                                  _vm._v(
                                    ". It just takes 30 seconds and won't mess up this form.\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.nps_value !== null && _vm.form.nps_value < 8
                            ? _c("v-textarea", {
                                staticClass: "pt-3",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  label: "What's the reason for this score?",
                                  "hide-details": "auto",
                                  rules: _vm.rules_text_limit,
                                  counter: "",
                                  maxlength: "255",
                                },
                                model: {
                                  value: _vm.form.nps_reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "nps_reason", $$v)
                                  },
                                  expression: "form.nps_reason",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4274897241
                ),
              }),
              _vm._v(" "),
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                Do you think you'll re-enroll in the future?\n            "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c(
                            "v-radio-group",
                            {
                              staticClass: "mt-0",
                              model: {
                                value: _vm.form.will_return,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "will_return", $$v)
                                },
                                expression: "form.will_return",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "Yes", value: true },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: { label: "No", value: false },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.will_return
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "soli-grey font-weight-bold text-start mb-4",
                                },
                                [
                                  _vm._v(
                                    "\n                    We'd love to have you back! When might you return?\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.will_return
                            ? _c("SoliDate", {
                                staticClass: "w-full",
                                attrs: {
                                  type: "month",
                                  rules: [],
                                  future: "",
                                  noLimit: "",
                                  select: false,
                                  label: "When might you re-enroll?",
                                },
                                model: {
                                  value: _vm.form.return_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "return_date", $$v)
                                  },
                                  expression: "form.return_date",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3388101437
                ),
              }),
              _vm._v(" "),
              _c("FormItem", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "question",
                      fn: function () {
                        return [_vm._v(" What could we do better? ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "response",
                      fn: function () {
                        return [
                          _c("v-textarea", {
                            attrs: {
                              label: "Your answer",
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              rules: _vm.rules_text_limit,
                              counter: "",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.form.do_better,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "do_better", $$v)
                              },
                              expression: "form.do_better",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  357008149
                ),
              }),
              _vm._v(" "),
              _vm.form.will_return
                ? _c("FormItem", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "question",
                          fn: function () {
                            return [
                              _vm._v(
                                "When you withdraw, your time and teacher will be made\n                available to other students. Many teachers have waiting\n                lists and there is no guarantee they will be available if\n                you wish to re-enroll. Please indicate below that you\n                understand.*"
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "response",
                          fn: function () {
                            return [
                              _c(
                                "v-checkbox",
                                {
                                  attrs: {
                                    label: "I understand",
                                    rules: [
                                      (val) => !!val || "This is required",
                                    ],
                                  },
                                  model: {
                                    value: _vm.form.agree,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "agree", $$v)
                                    },
                                    expression: "form.agree",
                                  },
                                },
                                [_vm._v("I understand")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      956663677
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("FormSubmit", {
                attrs: {
                  type: "submit",
                  errors: _vm.errors,
                  valid: _vm.valid,
                  dark: "",
                  loading: _vm.loading,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }